import React, { useState, useEffect } from "react";
import { DataGrid } from '@mui/x-data-grid'
import { useNavigate, Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash, faEye } from "@fortawesome/free-solid-svg-icons"; // import edit e trash icon
import DeleteConfirmation from "./../../components/DeleteConfirmation.js";
import "./../../App.css";
import localeToPortuguese from "./../../components/funcoes_gerais.js";
import { useHeader } from './../../components/HeaderContext';
import { useAxiosPrivate } from "./../../hooks/useAxiosPrivate.js";
import { encryptId } from './../../components/utils_react.jsx'
import useAuth from "./../../hooks/useAuth.js";
import OkModal from "./../../components/OkModal.js";
import { useAlert } from './../../components/AlertContext.jsx';


const Lots = () => {

    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const axiosPrivate = useAxiosPrivate();
    const { auth } = useAuth();

    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    const ReturnPage = "/lots";

    // texto do cabeçalho da pagina
    const { setHeader } = useHeader();
    useEffect(() => {
        setHeader("Lots");
    }, [setHeader]);

    const [type, setType] = useState(null);
    const [id, setId] = useState(null);         // usado no dialogo de confirmar delete e voltar
    const [displayConfirmationModal, setDisplayConfirmationModal] = useState(false);
    const [deleteMessage, setDeleteMessage] = useState(null);

    // Handle the displaying of the modal based on type and id
    const showDeleteModal = (type, id) => {
        setId(id);
        console.log(id);
        setDeleteMessage(`Are you sure you want to delete the record: ${type}?`);

        setDisplayConfirmationModal(true);
    };

    // Hide the modal
    const hideConfirmationModal = () => {
        setDisplayConfirmationModal(false);
    };


    const [showOkModal, setShowOkModal] = useState(false);
    const [okMessage, setOkMessage] = useState("");
    const [typeOkModal, setTypeOkModal] = useState("success");

    const handleShowOkModal = (message, type) => {
        setOkMessage(message);
        setTypeOkModal(type);
        setShowOkModal(true);
    }

    const handleHideOkModal = () => {
        setShowOkModal(false);
    };


    const { triggerAlert } = useAlert();

    const columns = [
        {
            field: 'actions',
            headerName: '',
            disableColumnMenu: true,
            width: 60,
            renderCell: (params) => (
                <div>
                    <FontAwesomeIcon icon={faEye} style={{ cursor: 'pointer', marginRight: '8px' }} onClick={() => ViewRow(params.row.lot_code, params.row.supplier_id)} />
                </div>
            ),
        },
        { field: 'lot_id', headerName: 'ID', disableColumnMenu: true },
        { field: 'lot_code', headerName: 'Lot Code', width: 160, headerClassName: 'super-app-theme--header', disableColumnMenu: true },
        { field: 'supplier_id', headerName: 'supplier_id', width: 50, disableColumnMenu: true },
        { field: 'code', headerName: 'Supplier', width: 300, disableColumnMenu: true },
        { field: 'name', headerName: 'Name', width: 300, disableColumnMenu: true },

    ]

    function ViewRow(lot_code, supplier_id) {
        console.log("lots.js > ViewRow > param1: ", lot_code);
        console.log("lots.js > ViewRow > param2: ", supplier_id);
        const encryptedId = encryptId(lot_code);

        navigate(`/lots_edit/${encryptedId}`, { state: { lot_code, supplier_id } });
    }


    function deleteRow(param1, param2) {
        console.log("lots.js > deleteRow > param1: ", param1, "param2: ", param2);
        showDeleteModal(param1, param2)
    }


    const handleSubmitDelete = async (id) => {
        console.log(id);
        try {
            setDisplayConfirmationModal(false);
            const res1 = await axiosPrivate.get(`${baseURL}/groups_allowdelete/` + id);
            let total_count = res1.data.total_count;
            console.log("total_count: ", total_count);

            if (total_count >= 1) {
                handleShowOkModal("Group in use. Record can't be deleted!", "warning");
            } else {
                try {
                    const res2 = await axiosPrivate.delete(`${baseURL}/groups/` + id);
                    let message = `Record deleted!`;
                    triggerAlert(message, 'success');
                    console.log(res2);
                    fetchLots();
                } catch (err) {
                    console.log('Error fetching data:', err);
                    console.log(err.response.data.err.originalError.info.message);
                    let message = `Erro na gravação!  \n ${err.response.data.err.originalError.info.message}`;
                    triggerAlert(message, 'error');
                }
            }
        } catch (err) {
            console.log('Error fetching data:', err);
            let message = `Erro na gravação!  \n ${err.response.data.err.originalError.info.message}`;
            triggerAlert(message, 'error');
        }
    };


    const [rows, setRows] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [limit, setPageSize] = useState(20);
    const [page, setPage] = useState(0);
    const [sortField, setSortField] = useState("lot_code");
    const [sortOrder, setSortOrder] = useState("asc");

    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 20, });


    useEffect(() => {
        fetchLots();
    }, [page, limit, sortField, sortOrder]);



    const fetchLots = async () => {
        try {

            setLoading(true);


            await axiosPrivate.get(`${baseURL}/lots_page?page=${page + 1}&limit=${limit}&sortfield=${sortField}&sortorder=${sortOrder}`)

                .then(result => {
                    console.log(result.data.result);
                    console.log("lots.js > fetchLots > result.data.result: ", result.data.result);

                    setLoading(false);

                    // return ok
                    if (result.status === 200) {
                        setRows(result.data.result.map(row => ({ id: row.lot_id, ...row })));
                        //setRows(result.data.rows);
                        setTotalRows(result.data.total_count);
                    }
                    else {
                        alert(result.data.Error);
                    }
                }).catch(err => console.log(err))
        } catch (error) {
            console.error('Failed to fetch products:', error);
            setLoading(false);
        }
    };




    function handlePageChange(newPage, newPageSize) {
        console.log("handlePageChange: ", newPage, " ", newPageSize, " atual limite: ", limit);

        if (newPageSize === limit) {
            setPage(newPage);
            setPaginationModel({ ...paginationModel, page: newPage, pageSize: limit });
            console.log("paginationModel: ", paginationModel);
        }
        else {
            setPage(0);
            setPageSize(newPageSize);
            console.log("mudou page size: ", paginationModel);
            setPaginationModel({ ...paginationModel, page: 0, pageSize: newPageSize });
        }
    }



    // Handler for sorting
    //const handleSortModelChange = (newSortModel) => {
    function handleSortModelChange(newSortModel) {
        const { field, sort } = newSortModel[0] || {};
        console.log("SortModel:", field, " ", sort);

        if (field) {
            setPage(0);
            setSortField(field);
            setSortOrder(sort);
            console.log("Field Page:", page);
        }
        else {
            setSortField("grupo");
            setSortOrder("asc");
        }

        setPaginationModel({ ...paginationModel, page: 0 });

    };


    const handleBtnNew = async () => {
        console.log("lots.js > handleBtnNew ");
        //navigate(`/groups_add`);
    };




    return (
        <div className="mt-2">

            <div className="row w-100 mb-2">
                <div className="col-1 d-flex flex-column justify-content-end d-none">
                    <div className="mt-auto">
                        <button type="button" className="btn btn-outline-success btn-sm mb-2" id="abrir" onClick={handleBtnNew}>+ New</button>
                    </div>
                </div>
            </div>

            <div style={{ width: '90%', position: 'relative' }}>
                <DataGrid

                    slotProps={{
                        pagination: {
                            showFirstButton: true,
                            showLastButton: true,
                        },
                    }}

                    page={page - 1}
                    rows={rows}
                    columns={columns}
                    rowHeight={40}
                    disableRowSelectionOnClick={true}
                    autoHeight={true}
                    paginationMode="server"
                    sortingMode="server"
                    density="compact"
                    rowCount={totalRows}
                    pagination

                    pageSizeOptions={[20, 40, 60]}

                    onCellClick={(params) => {
                        console.log("===cell click===", params);
                    }}

                    onPaginationModelChange={(params) => {
                        console.log("===page size===", params);
                        //console.log(params.page);
                        handlePageChange(params.page, params.pageSize);
                    }}

                    paginationModel={paginationModel}


                    initialState={{
                        pagination: { paginationModel: { page: 0, pageSize: 20 } },
                        // Hide column grupo_id, the other columns will remain visible
                        columns: { columnVisibilityModel: { lot_id: false, supplier_id: false } },

                    }}

                    onSortModelChange={handleSortModelChange}

                />
                <DeleteConfirmation showModal={displayConfirmationModal}
                    confirmModal={() => handleSubmitDelete(id)}
                    hideModal={hideConfirmationModal} type={type} id={id} message={deleteMessage} />


                <OkModal
                    showModal={showOkModal}
                    hideModal={handleHideOkModal}
                    message={okMessage}
                    type={typeOkModal}
                    header=""
                />

                {loading && (
                    <div className="overlay">
                        <div className="loading-circle"></div>
                    </div>
                )}



            </div>
        </div>
    );
}


export default Lots


